import { render, staticRenderFns } from "./ItemsImportList.vue?vue&type=template&id=70f10368&scoped=true&"
import script from "./ItemsImportList.vue?vue&type=script&lang=js&"
export * from "./ItemsImportList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsImportList.vue?vue&type=style&index=0&id=70f10368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f10368",
  null
  
)

export default component.exports